<template>
  <div id="scroll-view">
    <div
        class="category-title mb-2"
        :style="{
        'border-color': category.color
          ? category.color + '!important'
          : 'var(--v-primary-base)',
      }"
    >
      <h1
          class="title d-inline-block py-2 px-5 primary white--text"
          :style="{
          'background-color': category.color
            ? category.color + '!important'
            : 'var(--v-primary-base)',
        }"
      >
        {{ category.name }}
      </h1>
      <edit-asset-button
          :link="`/categories/edit/${category.slug}`"
      ></edit-asset-button>
    </div>
    <template v-if="loading">
      <v-row v-for="placeholder in Array(20).fill()" :key="placeholder" no-gutters dense class="mb-2">
        <v-col cols="12" md="3">
          <v-skeleton-loader
              max-width="200px"
              height="130px"
              type="image"
          ></v-skeleton-loader>
        </v-col>
        <v-col cols="12" md="9">
          <v-skeleton-loader
              max-width="100%"
              height="130px"
              type="paragraph"
          ></v-skeleton-loader>
        </v-col>
      </v-row>
    </template>

    <template v-else>
      <template v-if="category.view_layout === 'photo_list'">
        <article-card
            v-for="article in articles"
            :key="article.id"
            :data="article"
            class="mb-2"
        ></article-card>
      </template>
      <template v-else>
        <v-expansion-panels
            multiple
        >
          <v-expansion-panel
              v-for="article in articles"
              :key="article.id"
              class="mb-2">
            <v-expansion-panel-header class="title">{{ article.title }}</v-expansion-panel-header>
            <v-expansion-panel-content>
              <TextWidget :key="article.id" :text="article.description"></TextWidget>
              <DocumentsList :documents="article.documents"></DocumentsList>
            </v-expansion-panel-content>
            <v-expansion-panel-content>
              <v-btn text :to="`/articles/${article.slug}`">Vezi mai multe</v-btn>
            </v-expansion-panel-content>
          </v-expansion-panel>

        </v-expansion-panels>
      </template>
    </template>


    <v-pagination
        v-if="paginatorLength > 1"
        v-model="page"
        :length="paginatorLength"
        color="primary"
        :total-visible="6"
        @input="refresh"
    ></v-pagination>
  </div>
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex'
import ArticleCard from '~/components/article/cards/ArticleCard'
import DocumentsList from '~/components/article/DocumentsList'
import EditAssetButton from '~/components/common/EditAssetButton'
import TextWidget from '~/components/widget/TextWidget'

export default {
  name: 'CategoryView',
  components: {
    EditAssetButton,
    ArticleCard,
    TextWidget,
    DocumentsList,
  },
  beforeRouteLeave(to, from, next) {
    this.clearState({scope: 'categories', val: {}})
    this.resetScopeFilters('categories')
    this.resetScopeFilters('articles')

    localStorage.removeItem('articles-slug___ro_page')
    if (to.name === 'articles-slug___ro') {
      localStorage.setItem('articles-slug___ro_page', this.page)
    }

    next()
  },
  layout: 'client',
  auth: false,
  data() {
    return {
      page: 1,
    }
  },
  async fetch() {
    this.setFilter({
      scope: 'articles',
      val: this.$route.params.id,
      key: 'filter[category_id]',
    })

    this.setFilter({
      scope: 'articles',
      val: '-display_date',
      key: 'sort',
    })

    this.setItemsPerPage({
      scope: 'articles',
      itemsPerPage: 15,
    })

    await this.editResource({
      slug: this.$route.params.slug,
      key: 'slug',
      scope: 'categories',
    })

    if (process.client) {
      this.page = localStorage.getItem('articles-slug___ro_page') ? parseInt(localStorage.getItem('articles-slug___ro_page')) : 1
    }

    await this.refresh()
  },
  head() {
    return {
      title: 'Vizionare Categorie',
    }
  },
  async mounted() {
    await this.$nextTick()
    if (document.getElementById('scroll-view')) {
      this.$vuetify.goTo('#scroll-view', {
        offset: 100,
      })
    }
  },
  computed: {
    ...mapState('loader', ['loading']),
    ...mapState('articles', ['articles']),
    ...mapState('categories', ['category']),
    ...mapState('query', ['queryParams']),
    paginatorLength() {
      const total = this.queryParams.articles.pagination.total
      const perPage = this.queryParams.articles.pagination.itemsPerPage
      const remainder = total % perPage
      return Math.floor(total / perPage + (remainder ? 1 : 0))
    },
  },
  methods: {
    ...mapActions('resources', ['getData', 'editResource', 'clearState']),
    ...mapMutations('query', [
      'setFilter',
      'setTotalItems',
      'setResourcePagination',
      'setItemsPerPage',
      'resetScopeFilters',
    ]),
    async refresh() {
      this.setResourcePagination({
        scope: 'articles',
        pagination: {
          itemsPerPage: this.queryParams.articles.pagination.itemsPerPage,
          page: this.page,
        },
      })

      await this.getData('articles')
      if (document.getElementById('scroll-view')) {
        this.$vuetify.goTo('#scroll-view', {
          offset: 100,
        })
      }
    },
  },
}
</script>
